import React from 'react'
import { getStatusConfig } from '../helpers/specialPriceHelpers'

const getStatusModifier = (status = '') => String(status || 'unknown').toLowerCase().replace(/_/g, '-')

const SpecialPriceStatusBadge = ({ status, compact = false }) => {
  return (
    <span
      className={`special-price-status-badge${compact ? ' special-price-status-badge--compact' : ''} special-price-status-badge--${getStatusModifier(status)}`}
    >
      {getStatusConfig(status).label}
    </span>
  )
}

export default SpecialPriceStatusBadge
